import React from 'react'
import {useHistory, useLocation} from 'react-router-dom'
import AssessmentLink from 'components/AssessmentLink'
import {createPost} from 'helpers/command'

const startTest = createPost('quiz', 'startImportedAssessmentTest')
const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export default function ImportedAssessmentLessonLink ({assessments = [], context}) {
  const history = useHistory()
  const location = useLocation()
  const [busy, setBusy] = React.useState(false)
  const [error, setError] = React.useState('')

  async function open(source) {
    if (busy) return
    setBusy(true)
    setError('')
    try {
      const result = await startTest({id: source})
      const attempt = Array.isArray(result) ? result[0] : result
      if (typeof attempt !== 'string' || !uuid.test(attempt)) throw new Error('Unable to start imported assessment preview')
      history.push(`/${context.languageId}/${context.role}/quiz/imported-test/${attempt}?sourceId=${encodeURIComponent(source)}&returnTo=${encodeURIComponent(`${location.pathname}${location.search}`)}`)
    } catch (e) {
      setError('Unable to start imported assessment preview. Please try again.')
    } finally {
      setBusy(false)
    }
  }

  return <>
    <AssessmentLink assessments={assessments} context={context} onSelect={open} busy={busy} />
    {error && <span role="alert">{error}</span>}
  </>
}
